import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75ea5d7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publications py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "sidebar" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "widget-title" }, "Années", -1))
const _hoisted_8 = { class: "category-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1))
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = { class: "content-box" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "text-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueYears, (year) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: year,
                    onClick: ($event: any) => (_ctx.selectYear(year)),
                    class: _normalizeClass({ active: _ctx.selectedYear === year })
                  }, [
                    _createElementVNode("span", null, _toDisplayString(year), 1),
                    _hoisted_10
                  ], 10, _hoisted_9))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, " Textes - " + _toDisplayString(_ctx.selectedYear), 1),
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPublications, (pub) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: pub.id,
                  onClick: ($event: any) => (_ctx.goToDetail(pub.id))
                }, _toDisplayString(pub.titre), 9, _hoisted_15))
              }), 128))
            ]),
            (_ctx.filteredPublications.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Aucun texte disponible. "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}